<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<div class="wrapper">
  <div class="header">
    <ng-content select=".dialog-header"></ng-content>
  </div>

  <div class="content-box">
    <ng-content select=".dialog-content"></ng-content>
  </div>

  <div class="footer">
    <ng-content select=".dialog-footer"></ng-content>
  </div>
</div>
